import { Component, h } from 'preact'
import axios from 'axios'
import ForumContentCurationWrapper from '../content-curation/forum/ForumContentCurationWrapper'

interface Category {
  id: number
  title?: string
}

interface Props {
  id: number
  isKnowledgeBase: boolean
  isParentKnowledgeBase: boolean
  cdn: string
  forumId: number
  showExpandButton: boolean
  showHeader: boolean
  showAllLink: boolean
}

interface State {
  list: Category[]
}

class CategoryListWithTopics extends Component<Props, State> {
  state = {
    list: []
  }

  async componentDidMount () {
    if (this.props.isParentKnowledgeBase) {
      const { data } = await axios.get('/category/list', {
        params: {
          id: this.props.id
        }
      })

      this.setState({ list: data })
    } else {
      const category: Category = { id: this.props.id }
      this.setState({ list: [category] })
    }
  }

  render (props: Props, { list }: State) {
    return (
      <div>
        {
            list.map((item) => <ForumContentCurationWrapper
              key={item.id}
              {...props}
              {...item}
              forumId={item.id}
                               />)
          }
      </div>
    )
  }
}

export default CategoryListWithTopics
